import "./VehicleDocuemnts.scss";
import { reactPlugin } from "../../../../services/appInsights.service";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import _ from "lodash";
import { TesterService } from "../../../../services/tester.service";
import {
  DocumentGroup,
  VehicleDocumentsViewModel,
  Document,
  TesterVehicle,
  DocumentTypeLookUp,
} from "../../../../interfaces/tester.interface";
import { FileDrop } from "react-file-drop";
import { useEffect, useState, useContext, useMemo } from "react";
import { Row, Col, Button, Form, Modal } from "react-bootstrap";
import { ConfirmationModelPopup, ComponentModelPopup } from "../../../../interfaces/modal.interface";
import ErrorComponentModel from "../../appUtilityComponent/ErrorComponentModel/ErrorComponentModel";
import Spinner from "../../../components/Spinner";
import {
  Authorize,
  UserAuthContext,
} from "../../appLoginComponent/UserAuthContext";

type TParams = Readonly<{
  onClose: any;
  isReadonly: boolean;
  onDocumentsSave: any;
  vehicle: TesterVehicle;
  vehicleDocuments: VehicleDocumentsViewModel;
}>;


function VehicleDocuemnts({
  onClose,
  isReadonly,
  onDocumentsSave,
  vehicle,
  vehicleDocuments,
}: TParams) {
  let { isAuthorized } = useContext(UserAuthContext) as Authorize;
  let testerService = new TesterService();
  const [vehicleDocs, setVehicleDocs] = useState({} as VehicleDocumentsViewModel);

  const [isShowLoading, setIsShowLoading] = useState(false as boolean);

  const [fileDropError, setFileDropError] = useState("" as string);

  const [modal, setModal] = useState({} as ConfirmationModelPopup);

  const [errorModal, setErrorModal] = useState({
    Title: "Error",
    Show: false,
    Component: null,
    HandleClose: () => setErrorModal((prev) => ({ ...prev, Show: false }))
  } as ComponentModelPopup);

  const closeErrorModal = () => setErrorModal((prev) => ({ ...prev, Show: false }));
  const showErrorModal = (message: string) =>
    setErrorModal({
      Title: "Error",
      Show: true,
      Component: <div>{message}</div>,
      HandleClose: closeErrorModal
    });

  const [isUploding, setIsUploding] = useState(false as boolean);

  const [documentTypes, setDocumentTypes] = useState([] as DocumentTypeLookUp[]);

  const [documentGroups, setDocumentGroups] = useState<DocumentGroup[]>([]);



  const createEmptyDocumentGroup = (testerId: number): DocumentGroup => {
    return {
      testerId,
      documentGroupId: 0,
      documentGroupName: "",
      documents: [
        { documentId: -2, documentTitle: "", documentTypeId: "", documentLocation: "" },
        { documentId: -3, documentTitle: "", documentTypeId: "", documentLocation: "" },
        { documentId: -4, documentTitle: "", documentTypeId: "", documentLocation: "" },
        { documentId: -5, documentTitle: "", documentTypeId: "", documentLocation: "" },
        { documentId: -6, documentTitle: "", documentTypeId: "", documentLocation: "" },
      ],
    };
  };

  const initializeFromVehicleDocuments = () => {
    const _vehicleDocs = {
      vehicleId: vehicle.vehicleId,
      RegistrationDocument: vehicleDocuments.RegistrationDocument,
    } as VehicleDocumentsViewModel;

    _vehicleDocs.VehicleDocumentGroup = createEmptyDocumentGroup(vehicle.testerId);

    if (vehicleDocuments.VehicleDocumentGroup && vehicleDocuments.VehicleDocumentGroup.documents.length > 0) {
      _vehicleDocs.VehicleDocumentGroup.testerId = vehicle.testerId;
      _vehicleDocs.VehicleDocumentGroup.documentGroupId = vehicleDocuments.VehicleDocumentGroup.documentGroupId;
      _vehicleDocs.VehicleDocumentGroup.documentGroupName = vehicleDocuments.VehicleDocumentGroup.documentGroupName;

      for (let i = 0; i < vehicleDocuments.VehicleDocumentGroup.documents.length; i++) {
        _vehicleDocs.VehicleDocumentGroup.documents[i] = _.clone(vehicleDocuments.VehicleDocumentGroup.documents[i]);
      }
    }

    setVehicleDocs(_.clone(_vehicleDocs));
    setIsShowLoading(false);
  };

  const docSlotKeys = useMemo<string[]>(
    () => [0, 1, 2, 3, 4].map(i => `veh-${vehicle.vehicleId}-tid-${vehicle.testerId}-slot-${i}`),
    [vehicle.vehicleId, vehicle.testerId]
  );

  const buildVehicleDocsWithGroup = (result: VehicleDocumentsViewModel): VehicleDocumentsViewModel => {
    const hasRegDoc =
      (result?.RegistrationDocument?.documentId ?? 0) > 0 ||
      (result?.RegistrationDocument?.documentTitle?.length ?? 0) > 0 ||
      (result?.RegistrationDocument?.documentGroupId ?? 0) > 0;
    const _vehicleDocs: VehicleDocumentsViewModel = {
      vehicleId: vehicle.vehicleId,
      RegistrationDocument: hasRegDoc
        ? result.RegistrationDocument
        : { documentId: -1, documentTitle: "", documentTypeId: "REG", documentLocation: "" },
    };
    _vehicleDocs.VehicleDocumentGroup = createEmptyDocumentGroup(vehicle.testerId);
    const groupDocs = result?.VehicleDocumentGroup?.documents;
    if ((groupDocs?.length ?? 0) > 0) {
      _vehicleDocs.VehicleDocumentGroup.testerId = vehicle.testerId;
      _vehicleDocs.VehicleDocumentGroup.documentGroupId = result?.VehicleDocumentGroup?.documentGroupId ?? 0;
      const vehicleDocGroup = vehicle.vehicleDocuments?.find(x => (x.documentGroupId ?? -1) >= 0);
      _vehicleDocs.VehicleDocumentGroup.documentGroupName = vehicleDocGroup?.documentGroupDetails?.documentGroupName ?? "";
      groupDocs!.forEach((doc, i) => {
        if (doc) { _vehicleDocs.VehicleDocumentGroup!.documents[i] = _.clone(doc); }
      });
    }
    return _vehicleDocs;
  };

  const loadVehicleDocuments = async () => {
    try {
      if (vehicle.documentGroupId && vehicle.documentGroupId > 0) {
        const res = await testerService.GetDocumentsByVehicleId(vehicle.documentGroupId);

        if (res.statusCode === "N") {
          const errorMessage = res.statusMessage || "Failed to load vehicle documents";
          console.error("GetDocumentsByVehicleId error:", errorMessage);
          showErrorModal(errorMessage);
          setIsShowLoading(false);
          return;
        }

        if (!res.result) {
          showErrorModal("No document data returned from server");
          setIsShowLoading(false);
          return;
        }

        res.result.vehicleId = vehicle.vehicleId;
        const regDocEntry = vehicle.vehicleDocuments?.find(x => !x.documentGroupId)
          ?? vehicle.vehicleDocuments?.find(x => x.documentTypeId === "REG");
        res.result.RegistrationDocument = regDocEntry?.document ?? regDocEntry;
        setVehicleDocs(_.clone(buildVehicleDocsWithGroup(res.result)));
        setIsShowLoading(false);
      } else {
        const regDocLink = vehicle.vehicleDocuments?.find(x => !x.documentGroupId)
          ?? vehicle.vehicleDocuments?.find(x => x.documentTypeId === "REG");
        const _vehicleDocs = {
          vehicleId: vehicle.vehicleId,
          RegistrationDocument: regDocLink?.document ?? regDocLink ?? { documentTitle: '', documentId: 0 },
        } as VehicleDocumentsViewModel;

        _vehicleDocs.VehicleDocumentGroup = createEmptyDocumentGroup(vehicle.testerId);
        setVehicleDocs(_.clone(_vehicleDocs));
        setIsShowLoading(false);
      }
    } catch (error: any) {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading vehicle documents";
      console.error("GetDocumentsByVehicleId exception:", error);
      showErrorModal(message);
      setIsShowLoading(false);
    }
  };

  const loadDocumentsByDocumentId = async () => {
    try {
      let _vehicleDocs = {
        vehicleId: vehicle.vehicleId,
        RegistrationDocument: {
          documentId: -1,
          documentTitle: "",
          documentTypeId: "REG",
          documentLocation: "",
        },
      } as VehicleDocumentsViewModel;

      _vehicleDocs.VehicleDocumentGroup = createEmptyDocumentGroup(vehicle.testerId);

      const res = await testerService.GetDocumentById(vehicle.documentId);
      if (res.statusCode === "N") {
        const errorMessage = res.statusMessage || "Failed to load registration document";
        console.error("GetDocumentById error:", errorMessage);
        showErrorModal(errorMessage);
        setIsShowLoading(false);
        return;
      }

      if (!res.result) {
        showErrorModal("No registration document returned from server");
        setIsShowLoading(false);
        return;
      }
      _vehicleDocs.RegistrationDocument = res.result;

      if (vehicle.documentGroupId > 0) {
        const groupRes = await testerService.GetDocumentGroupById(vehicle.documentGroupId);
        if (groupRes.statusCode === "N") {
          const errorMessage = groupRes.statusMessage || "Failed to load document group";
          console.error("GetDocumentGroupById error:", errorMessage);
          showErrorModal(errorMessage);
          setIsShowLoading(false);
          return;
        }

        if (groupRes.result && groupRes.result.documentGroupId > 0) {
          _vehicleDocs.VehicleDocumentGroup.testerId = groupRes.result.testerId;
          _vehicleDocs.VehicleDocumentGroup.documentGroupId = groupRes.result.documentGroupId;
          _vehicleDocs.VehicleDocumentGroup.documentGroupName = groupRes.result.documentGroupName;

          for (let i = 0; i < groupRes.result.documents.length; i++) {
            _vehicleDocs.VehicleDocumentGroup.documents[i] = _.clone(groupRes.result.documents[i]);
          }
        }
      }

      setVehicleDocs(_.clone(_vehicleDocs));
      setIsShowLoading(false);
    } catch (error: any) {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading documents";
      console.error("loadDocumentsByDocumentId exception:", error);
      showErrorModal(message);
      setIsShowLoading(false);
    }
  };

  useEffect(() => {
    setIsShowLoading(true);

    if ((vehicleDocuments?.RegistrationDocument?.documentId ?? 0) > 0) {
      initializeFromVehicleDocuments();
    } else if (vehicle.vehicleId > 0) {
      loadVehicleDocuments();
    } else if (vehicle.documentId > 0) {
      loadDocumentsByDocumentId();
    } else {
      const _vehicleDocs = {
        vehicleId: vehicle.vehicleId,
        RegistrationDocument: {
          documentId: -1,
          documentTitle: "",
          documentTypeId: "REG",
          documentLocation: "",
        },
      } as VehicleDocumentsViewModel;
      _vehicleDocs.VehicleDocumentGroup = createEmptyDocumentGroup(vehicle.testerId);
      setVehicleDocs(_.clone(_vehicleDocs));
      setIsShowLoading(false);
    }

    testerService.GetDocumentGroupsByTesterId(vehicle.testerId).then((res) => {
      if (res.statusCode === "N") {
        const errorMessage = res.statusMessage || "Failed to load document groups";
        console.error("GetDocumentGroupsByTesterId error:", errorMessage);
        setErrorModal({
          Title: "Error",
          Show: true,
          Component: <div>{errorMessage}</div>,
          HandleClose: () => setErrorModal({ ...errorModal, Show: false })
        });
        return;
      }
      setDocumentGroups(res.result || []);
    }).catch((error: any) => {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading document groups";
      console.error("GetDocumentGroupsByTesterId exception:", error);
      setErrorModal({
        Title: "Error",
        Show: true,
        Component: <div>{message}</div>,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
      });
    });

    testerService.GetDocumentTypeLookUp().then((res) => {
      if (res.statusCode === "N") {
        const errorMessage = res.statusMessage || "Failed to load document types";
        console.error("GetDocumentTypeLookUp error:", errorMessage);
        setErrorModal({
          Title: "Error",
          Show: true,
          Component: <div>{errorMessage}</div>,
          HandleClose: () => setErrorModal({ ...errorModal, Show: false })
        });
        return;
      }
      setDocumentTypes((res.result || []).filter((x) => x.DocumentTypeCode !== "REG"));
    }).catch((error: any) => {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading document types";
      console.error("GetDocumentTypeLookUp exception:", error);
      setErrorModal({
        Title: "Error",
        Show: true,
        Component: <div>{message}</div>,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
      });
    });
  }, [vehicle.testerId, vehicle.vehicleId, vehicleDocuments]);

  const OnAdditionDocTypeChange = (
    documentId: number,
    documentType: string
  ) => {
    const _vehicleDocs = vehicleDocs;

    const document = _vehicleDocs?.VehicleDocumentGroup?.documents?.find(
      (x) => (x.documentId ?? 0) === documentId
    );
    if (document) {
      document.documentTypeId = documentType;
    }

    setVehicleDocs(_.clone(_vehicleDocs));
  };

  const onDocumentGroupChange = async (docGroupId: number) => {
    setIsShowLoading(true);

    try {
      const _vehicleDocs = _.clone(vehicleDocs);

      _vehicleDocs.VehicleDocumentGroup = {
        testerId: vehicle.testerId,
        documentGroupId: 0,
        documentGroupName: "",
        documents: [
          {
            documentId: -2,
            documentTitle: "",
            documentTypeId: "",
            documentLocation: "",
          },
          {
            documentId: -3,
            documentTitle: "",
            documentTypeId: "",
            documentLocation: "",
          },
          {
            documentId: -4,
            documentTitle: "",
            documentTypeId: "",
            documentLocation: "",
          },
          {
            documentId: -5,
            documentTitle: "",
            documentTypeId: "",
            documentLocation: "",
          },
          {
            documentId: -6,
            documentTitle: "",
            documentTypeId: "",
            documentLocation: "",
          },
        ],
      };

      if (docGroupId > 0) {
        const _docGroup = documentGroups.find(
          (x) => x.documentGroupId === docGroupId
        );

        if (!_docGroup) {
          setIsShowLoading(false);
          return;
        }

        _vehicleDocs.VehicleDocumentGroup.testerId = _docGroup.testerId;
        _vehicleDocs.VehicleDocumentGroup.documentGroupId =
          _docGroup.documentGroupId;
        _vehicleDocs.VehicleDocumentGroup.documentGroupName =
          _docGroup.documentGroupName;

        const newDocs = await testerService.GetDocumentGroupById(
          _docGroup.documentGroupId
        );

        if (newDocs.statusCode === "N") {
          const errorMessage = newDocs.statusMessage || "Failed to load document group";
          console.error("GetDocumentGroupById error:", errorMessage);
          showErrorModal(errorMessage);
          setIsShowLoading(false);
          return;
        }

        if (!newDocs.result) {
          showErrorModal("No document group data returned from server");
          setIsShowLoading(false);
          return;
        }

        for (let i = 0; i < newDocs.result.documents.length; i++) {
          _vehicleDocs.VehicleDocumentGroup.documents[i] = _.clone(
            newDocs.result.documents[i]
          );
        }
      }

      setVehicleDocs(_.clone(_vehicleDocs));
    } catch (error: any) {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while loading document group";
      console.error("onDocumentGroupChange exception:", error);
      showErrorModal(message);
    } finally {
      setIsShowLoading(false);
    }
  };

  const UploadRegistationFile = async (file: File) => {
    const _vehicleDocs = _.clone(vehicleDocs) || {};

    if (_vehicleDocs.RegistrationDocument) {
      _vehicleDocs.RegistrationDocument.documentTitle = file.name;
      _vehicleDocs.RegistrationDocument.documentTypeId = "REG";
      _vehicleDocs.RegistrationDocument.File = file;
    }

    setVehicleDocs(_.clone(_vehicleDocs));
  };

  const onRegistarionFileDrop = (
    files: FileList,
    event: React.DragEvent<HTMLDivElement>
  ) => {
    event.preventDefault();

    const file = files.item(0);
    if (file && file.name.length > 100) {
      setErrorModal({
        Title: "File Name Too Long",
        Component: (
          <div>
            <p>File name must be less than 100 characters.</p>
            <p><strong>{file.name.substring(0, 50)}...</strong></p>
          </div>
        ),
        Show: true,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
      });
      return;
    }
    UploadRegistationFile(files.item(0) as File);
  };

  const UploadFile = async (files: FileList) => {
    setFileDropError("");

    const _vehicleDocs = structuredClone(vehicleDocs) || {};

    if (_vehicleDocs.VehicleDocumentGroup?.documents) {
      _vehicleDocs.VehicleDocumentGroup.documents =
        _vehicleDocs.VehicleDocumentGroup.documents.filter(
          (x: any) => (x.documentTitle?.length ?? 0) > 0
        );
    }

    const _vehicleGroupDocs = vehicleDocs.VehicleDocumentGroup?.documents?.filter(
      (x: any) => (x.documentTitle?.length ?? 0) === 0
    ) || [];

    if (files.length > _vehicleGroupDocs.length) {
      setFileDropError("Only " + _vehicleGroupDocs.length + " files allowed.");
      return;
    }

    for (let i = 0; i < files.length; i++) {
      if (_vehicleGroupDocs[i]) {
        _vehicleGroupDocs[i].documentTitle = files.item(i)?.name as string;
        _vehicleGroupDocs[i].File = files.item(i) as File;
      }
    }

    if (_vehicleDocs.VehicleDocumentGroup) {
      _vehicleDocs.VehicleDocumentGroup.documents = (_vehicleDocs.VehicleDocumentGroup.documents || []).concat(_vehicleGroupDocs);
    }

    setVehicleDocs(_.clone(_vehicleDocs));
  };

  const onFilesDrop = (
    files: FileList | null,
    event: React.DragEvent<HTMLDivElement>
  ) => {

    let fileNamesExceptions: string[] = [];

    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const currentFile = files.item(i);
        if (!currentFile?.type.endsWith("pdf")) {
          return;
        }
        else if (currentFile && currentFile.name.length > 100) {
          fileNamesExceptions.push(currentFile.name);
        }
      }

      if (fileNamesExceptions.length > 0) {
        setErrorModal({
          Title: "File Names Too Long",
          Component: (
            <div>
              <p>The following file name(s) must be less than 100 characters:</p>
              <ul>
                {fileNamesExceptions.map((name, index) => (
                  <li key={`${name}-${index}`}><strong>{name.substring(0, 50)}...</strong></li>
                ))}
              </ul>
            </div>
          ),
          Show: true,
          HandleClose: () => setErrorModal({ ...errorModal, Show: false })
        });
        return;
      }

      UploadFile(files);
    }

    event.preventDefault();
  };

  const showUpdateOrCreateModal = () => {
    setIsCreateNewGroup(false);
    setModal({
      Title: "Do you want to update documents in existing group or create new group?",
      Show: true,
      OkText: "Create New Group",
      HandleOk: createNewGroup,
      CancelText: "Update Existing Group",
      HandleClose: onUploadConfirmation,
    } as ConfirmationModelPopup);
  };

  const showCreateNewGroupModal = () => {
    setIsCreateNewGroup(true);
    const _vehicleDocs = _.clone(vehicleDocs) || {};
    if (_vehicleDocs.VehicleDocumentGroup) {
      _vehicleDocs.VehicleDocumentGroup.documentGroupName = "";
      _vehicleDocs.VehicleDocumentGroup.IsNewGroup = true;
    }
    setVehicleDocs(_.clone(_vehicleDocs));

    setModal({
      Title: "Create a document group to upload documents.",
      Show: true,
      OkText: "Save",
      HandleOk: onUploadConfirmation,
      CancelText: "Cancel",
      HandleClose: handleModalClose,
    } as ConfirmationModelPopup);
  };

  const showConfirmUploadModal = () => {
    setIsCreateNewGroup(false);
    setModal({
      Title: "Are you sure you want to upload documents?",
      Show: true,
      OkText: "Save",
      HandleOk: onUploadConfirmation,
      CancelText: "Cancel",
      HandleClose: handleModalClose,
    } as ConfirmationModelPopup);
  };

  const hasNewDocumentsInExistingGroup = () => {
    return (
      (vehicleDocs?.VehicleDocumentGroup?.documentGroupId ?? 0) > 0 &&
      (vehicleDocs?.VehicleDocumentGroup?.documents?.some((x) => (x.documentId ?? 0) < 0) ?? false)
    );
  };

  const needsNewDocumentGroup = () => {
    return (
      (vehicleDocs?.VehicleDocumentGroup?.documentGroupId ?? 0) === 0 &&
      (vehicleDocs?.VehicleDocumentGroup?.documents?.some((x) => (x.documentTitle?.length ?? 0) > 0) ?? false)
    );
  };

  const onUploadClick = () => {
    if (hasNewDocumentsInExistingGroup()) {
      showUpdateOrCreateModal();
      return;
    }

    if (needsNewDocumentGroup()) {
      showCreateNewGroupModal();
      return;
    }

    showConfirmUploadModal();
  };

  const uploadRegistrationDocument = async () => {
    const _regDoc = vehicleDocs?.RegistrationDocument;
    if (_regDoc) {
      _regDoc.testerId = vehicle.testerId;
      _regDoc.isActive = "Y";

      if (_regDoc.File && !_regDoc.documentLocation) {
        _regDoc.documentLocation = await testerService.UploadFile(_regDoc.File);
      }
    }
  };

  const prepareDocumentForUpload = (doc: any) => {
    doc.testerId = vehicle.testerId;
    doc.isActive = "Y";
    doc.documentId = vehicleDocs?.VehicleDocumentGroup?.IsNewGroup ? 0 : Math.max(0, doc.documentId ?? 0);
  };

  const uploadDocumentFile = async (doc: Document) => {
    if ((doc.documentId ?? 0) >= 0 && doc.File && !doc.documentLocation) {
      doc.documentLocation = await testerService.UploadFile(doc.File);
    }
  };

  const processDocumentGroup = async () => {
    const _group = vehicleDocs?.VehicleDocumentGroup as any;
    if (!_group?.documents) return;

    _group.documents = (_group.documents as any[]).filter(
      (x: any) => (x.documentTitle?.length ?? 0) > 0
    );

    if (_group.documents.length === 0) {
      return;
    }

    _group.testerId = vehicle.testerId;

    if (_group.IsNewGroup) {
      _group.documentGroupId = 0;
    }

    for (const doc of _group.documents) {
      prepareDocumentForUpload(doc);
      await uploadDocumentFile(doc);
    }
  };

  const saveDocuments = async () => {
    const res = await testerService.SaveVehicleDocuments(vehicleDocs);
    if (res?.statusCode === "N") {
      const errorMessage = res?.statusMessage || "Failed to save vehicle documents";
      console.error("SaveVehicleDocuments error:", errorMessage);
      showErrorModal(errorMessage);
      return false;
    }
    return res?.result;
  };

  const onUploadConfirmation = async () => {
    setIsShowLoading(true);
    setIsUploding(true);

    try {
      await uploadRegistrationDocument();
      await processDocumentGroup();

      const result = await saveDocuments();
      if (result) {
        onDocumentsSave(result);
        handleModalClose();
      }
    } catch (error: any) {
      const message = error?.statusMessage || error?.message || " An unexpected error occurred while saving documents";
      console.error("onUploadConfirmation exception:", error);
      showErrorModal(message);
    } finally {
      setIsUploding(false);
      setIsShowLoading(false);
    }
  };

  const [isCreateNewGroup, setIsCreateNewGroup] = useState(false as boolean);

  const createNewGroup = () => {
    setIsCreateNewGroup(true);

    const _vehicleDocs = _.clone(vehicleDocs) || {};
    if (_vehicleDocs.VehicleDocumentGroup) {
      _vehicleDocs.VehicleDocumentGroup.documentGroupName = "";
      _vehicleDocs.VehicleDocumentGroup.IsNewGroup = true;
    }

    setVehicleDocs(_.clone(_vehicleDocs));

    setModal({
      Title: "Please provide the new group name and Save",
      Show: true,
      OkText: "Save",
      HandleOk: () => {
        onUploadConfirmation();
      },
      CancelText: "Cancel",
      HandleClose: handleModalClose,
    } as ConfirmationModelPopup);
  };

  const setNewGroupName = (groupName: string) => {
    const _vehicleDocs = vehicleDocs;

    if (_vehicleDocs.VehicleDocumentGroup) {
      _vehicleDocs.VehicleDocumentGroup.documentGroupName = groupName;
    }

    setVehicleDocs(_.clone(vehicleDocs));
  };

  const handleModalClose = () => {
    setModal({
      Title: "",
      Show: false,
    } as ConfirmationModelPopup);
  };

  const OnRegistationDocDelete = () => {
    setModal({
      Title: "Are you sure you want to delete the document?",
      Show: true,
      OkText: "Delete",
      OkVariant: "btn-delete",
      HandleOk: () => OnRegistationDocDeleteConfirmation(),
      CancelText: "Cancel",
      HandleClose: handleModalClose,
    } as ConfirmationModelPopup);
  };

  const OnRegistationDocDeleteConfirmation = async () => {
    //await testerService.DeleteDocument(vehicleDocs.RegistrationDocument)

    const _vehicleDocs = vehicleDocs;

    if (_vehicleDocs.RegistrationDocument) {
      _vehicleDocs.RegistrationDocument.documentTitle = "";
      _vehicleDocs.RegistrationDocument.documentLocation = "";
      _vehicleDocs.RegistrationDocument.File = undefined;
    }

    setVehicleDocs(_.clone(_vehicleDocs));

    handleModalClose();
  };

  const OnAdditionalDocDelete = (documentId: number) => {
    setModal({
      Title: "Are you sure you want to delete the document?",
      Show: true,
      OkText: "Delete",
      OkVariant: "btn-delete",
      HandleOk: () => OnAdditionalDocDeleteConfirmation(documentId),
      CancelText: "Cancel",
      HandleClose: handleModalClose,
    } as ConfirmationModelPopup);
  };

  const OnAdditionalDocDeleteConfirmation = async (documentId: number) => {
    const _vehicleDocs = vehicleDocs;

    if (_vehicleDocs.VehicleDocumentGroup) {
      const docIndex = _vehicleDocs.VehicleDocumentGroup.documents.findIndex(
        (x) => x.documentId === documentId
      );

      _vehicleDocs.VehicleDocumentGroup.documents[docIndex].documentId =
        documentId < 0 ? documentId : -1 * documentId;
      _vehicleDocs.VehicleDocumentGroup.documents[docIndex].documentTitle = "";
      _vehicleDocs.VehicleDocumentGroup.documents[docIndex].documentTypeId = "";
      _vehicleDocs.VehicleDocumentGroup.documents[docIndex].documentLocation = "";
      _vehicleDocs.VehicleDocumentGroup.documents[docIndex].File = undefined;
    }

    setVehicleDocs(_.clone(_vehicleDocs));

    handleModalClose();
  };

  const OnDocView = async (document: Document) => {
    setIsShowLoading(true);
    try {
      const res = await testerService.DownloadFile(document);
      if (res && typeof res === 'object' && 'statusCode' in res && (res as any).statusCode === "N") {
        const errorMessage = (res as any).statusMessage || "Failed to download document";
        console.error("DownloadFile error:", errorMessage);
        showErrorModal(errorMessage);
      }
    } catch (error: any) {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while downloading document";
      console.error("DownloadFile exception:", error);
      showErrorModal(message);
    } finally {
      setIsShowLoading(false);
    }
  };

  if (isReadonly && vehicleDocs?.RegistrationDocument?.documentId === 0) {
    return <>
      <p className="mt-0">
        No Documents Uploaded.
      </p>
      <Button
        className="ml-2 shadow-sm cursor-shadow btn-default btn-cancel"
        variant="light"
        onClick={onClose}>
        Close
      </Button>
    </>
  }
  return (
    <>
      <ErrorComponentModel modal={errorModal} />
      {vehicleDocs?.RegistrationDocument && (
        <>
          {!isReadonly &&
            (vehicleDocs.RegistrationDocument.documentTitle?.length ?? 0) === 0 && (
              <Row>
                <div className="col-sm-12 text-center">
                  <div className="file-drop-wrapper">
                    <FileDrop
                      onDrop={(files, event) =>
                        onRegistarionFileDrop(files as FileList, event)
                      }
                    >
                      DRAG & DROP REGISTRATION DOCUMENT HERE
                    </FileDrop>
                  </div>
                  <br />
                </div>
              </Row>
            )}
          <Form>
            <Row>
              <Col>
                <Row>
                  <Form.Group
                    as={Col}
                    sm={6}
                    className={
                      "mb-1 form-floating " +
                      ((vehicleDocs.RegistrationDocument.documentTitle?.length ?? 0) > 0
                        ? "filled"
                        : "")
                    }
                  >
                    <Form.Control
                      value={vehicleDocs.RegistrationDocument.documentTitle ?? ""}
                      readOnly
                      disabled
                    ></Form.Control>
                    <Form.Label className="mb-0">Document Name</Form.Label>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    sm={6}
                    className={"mb-1 filled form-floating"}
                  >
                    <Form.Control
                      value="Proof of Current Registration"
                      disabled
                    ></Form.Control>
                    <Form.Label className="mb-0">Document Type</Form.Label>
                  </Form.Group>
                </Row>
              </Col>
              <Col
                className={
                  "col-lg text-right " +
                  (isReadonly ? "mw-md-150px" : "mw-md-300px")
                }
              >
                <Row>
                  <Form.Group as={Col} sm={12} className="text-right">
                    <Button
                      disabled={
                        !(vehicleDocs.RegistrationDocument.documentLocation?.length ?? 0)
                      }
                      variant="light"
                      className="btn-default btn-save me-2"
                      onClick={() => {
                        if (vehicleDocs.RegistrationDocument) {
                          OnDocView(vehicleDocs.RegistrationDocument);
                        }
                      }}
                    >
                      VIEW
                    </Button>
                    {!isReadonly && (
                      <Button
                        disabled={
                          (vehicleDocs.RegistrationDocument.documentTitle?.length ?? 0) === 0
                        }
                        variant="light"
                        className="btn-default btn-delete"
                        onClick={OnRegistationDocDelete}
                      >
                        DELETE
                      </Button>
                    )}
                  </Form.Group>
                </Row>
              </Col>
            </Row>
            {(isReadonly
              ? true
              : isAuthorized("AV_Veh_Document_Add") &&
              ((vehicleDocs.RegistrationDocument.documentId ?? 0) > 0 ||
                (vehicleDocs.RegistrationDocument.documentTitle?.length ?? 0) > 0)) && (
                <>
                  {!isReadonly && (
                    <>
                      {(vehicleDocs.VehicleDocumentGroup?.documents?.filter(
                        (d) => (d.documentTitle?.length ?? 0) > 0
                      )?.length ?? 0) < 5 && (
                          <>
                            <div className="col-sm-12 text-center">
                              <div className="file-drop-wrapper">
                                <FileDrop
                                  onDrop={(files, event) =>
                                    onFilesDrop(files, event)
                                  }
                                >
                                  DRAG & DROP UP TO{" "}
                                  {5 -
                                    (vehicleDocs.VehicleDocumentGroup?.documents?.filter(
                                      (d) => (d.documentTitle?.length ?? 0) > 0
                                    )?.length ?? 0)}{" "}
                                  ADDITIONAL DOCUMENTS HERE
                                </FileDrop>
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <span className="text-danger">{fileDropError}</span>
                              <br />
                            </div>
                          </>
                        )}

                      {documentGroups && documentGroups.length > 0 && (
                        <Row>
                          <Form.Group
                            as={Col}
                            sm={12}
                            className={
                              "mb-2 mt-2 form-floating " +
                              ((vehicleDocs.VehicleDocumentGroup?.documentGroupId ?? 0) >
                                0
                                ? "filled"
                                : "")
                            }
                          >
                            <Form.Control
                              as="select"
                              value={
                                vehicleDocs.VehicleDocumentGroup?.documentGroupId ?? 0
                              }
                              onChange={(e) => {
                                onDocumentGroupChange(+e.target.value);
                              }}
                            >
                              <option value={0}></option>
                              {documentGroups.map((x) => (
                                <option
                                  key={x.documentGroupId}
                                  value={x.documentGroupId}
                                >
                                  &nbsp;&nbsp;{x.documentGroupName}
                                </option>
                              ))}
                            </Form.Control>

                            <span style={{ position: 'absolute', right: '10px', pointerEvents: 'none', top: '50%', transform: 'translateY(-50%)' }} className='vehicle-filter-icon'></span>

                            <Form.Label className="mb-0">
                              Document Group
                            </Form.Label>
                          </Form.Group>
                        </Row>
                      )}
                    </>
                  )}
                  {isReadonly &&
                    (vehicleDocs.VehicleDocumentGroup?.documentGroupId ?? 0) > 0 &&
                    documentGroups &&
                    documentGroups.length > 0 && (
                      <Row className="mb-2">
                        <Col className="text-start">
                          <h5>
                            {
                              documentGroups.find(
                                (d) =>
                                  d.documentGroupId ===
                                  vehicleDocs.VehicleDocumentGroup?.documentGroupId
                              )?.documentGroupName
                            }
                          </h5>
                        </Col>
                      </Row>
                    )}

                  {(vehicleDocs.VehicleDocumentGroup?.documents?.length ?? 0) > 0 &&
                    vehicleDocs.VehicleDocumentGroup?.documents?.map((x, i) => (
                      <div key={docSlotKeys[i]}>
                        {(!isReadonly || (x.documentId ?? 0) > 0) && (
                          <Row>
                            <Col>
                              <Row>
                                <Form.Group
                                  as={Col}
                                  sm={6}
                                  className={
                                    "mb-1 form-floating " +
                                    ((x.documentTitle?.length ?? 0) > 0 ? "filled" : "")
                                  }
                                >
                                  <Form.Control
                                    value={x.documentTitle ?? ""}
                                    readOnly
                                    disabled
                                  ></Form.Control>
                                  <Form.Label className="mb-0">
                                    Document Name
                                  </Form.Label>
                                </Form.Group>
                                <Form.Group
                                  as={Col}
                                  sm={6}
                                  className={
                                    "mb-1 form-floating " +
                                    ((x.documentTypeId?.length ?? 0) > 0
                                      ? "filled"
                                      : "") +
                                    ((x.documentTitle?.length ?? 0) > 0
                                      ? " required"
                                      : "")
                                  }
                                >
                                  <Form.Control
                                    as="select"
                                    value={x.documentTypeId ?? ""}
                                    onChange={(e) =>
                                      OnAdditionDocTypeChange(
                                        x.documentId ?? 0,
                                        e.target.value
                                      )
                                    }
                                    disabled={isReadonly}
                                  >
                                    <option value=""></option>
                                    {documentTypes.map((documentType) => (
                                      <option
                                        key={documentType.DocumentTypeCode}
                                        disabled={
                                          (vehicleDocs.VehicleDocumentGroup?.documents ?? [])
                                            .map((d) => d.documentTypeId)
                                            .includes(
                                              documentType.DocumentTypeCode
                                            )
                                        }
                                        value={documentType.DocumentTypeCode}
                                      >
                                        &nbsp;&nbsp;{documentType.DocumentTypeName}
                                      </option>
                                    ))}
                                  </Form.Control>

                                  <span style={{ position: 'absolute', right: '10px', pointerEvents: 'none', top: '50%', transform: 'translateY(-50%)' }} className='vehicle-filter-icon'></span>

                                  <Form.Label className="mb-0">
                                    Document Type
                                  </Form.Label>
                                </Form.Group>
                              </Row>
                            </Col>
                            <Col
                              className={
                                "col-lg text-right " +
                                (isReadonly ? "mw-md-150px" : "mw-md-300px")
                              }
                            >
                              <Row>
                                <Form.Group
                                  as={Col}
                                  sm={12}
                                  className="text-right"
                                >
                                  <Button
                                    disabled={
                                      !(x.documentLocation?.length ?? 0)
                                    }
                                    variant="light"
                                    className="btn-default btn-save me-2"
                                    onClick={() => {
                                      OnDocView(x);
                                    }}
                                  >
                                    VIEW
                                  </Button>
                                  {!isReadonly && (
                                    <Button
                                      disabled={(x.documentTitle?.length ?? 0) === 0}
                                      variant="light"
                                      className="btn-default btn-delete"
                                      onClick={() => {
                                        OnAdditionalDocDelete(x.documentId ?? 0);
                                      }}
                                    >
                                      DELETE
                                    </Button>
                                  )}
                                </Form.Group>
                              </Row>
                            </Col>
                          </Row>
                        )}
                      </div>
                    ))}
                </>
              )}
          </Form>

          <Row>

            {!isReadonly && (<Col className="text-left mt-2" sm="auto">

              <Button
                className="shadow-sm cursor-shadow btn-save btn-default"
                disabled={
                  (vehicleDocs.RegistrationDocument.documentTitle?.length ?? 0) === 0 ||
                  (vehicleDocs.VehicleDocumentGroup?.documents?.some(
                    (d) =>
                      (d.documentTitle?.length ?? 0) > 0 &&
                      (d.documentTypeId?.length ?? 0) === 0
                  ) ?? false)
                }
                variant="light"
                onClick={onUploadClick}
              >
                {(vehicleDocs.VehicleDocumentGroup?.documents?.some(
                  (d) =>
                    (d.documentTitle?.length ?? 0) > 0 &&
                    (d.documentTypeId?.length ?? 0) === 0
                ) ?? false)
                  ? "Upload documents"
                  : "Upload document"}{" "}
              </Button>
            </Col>
            )}

            <Col className="text-left mt-2" sm="auto">
              <Button
                className="shadow-sm cursor-shadow btn-default btn-cancel"
                variant="light"
                onClick={onClose}
              >
                Close
              </Button>
            </Col>
          </Row>

          {!isReadonly && (
            <Modal
              className="modal-main-box"
              show={modal.Show}
              onHide={handleModalClose}
              backdrop="static"
              keyboard={false}
            >
              {modal.Title && modal.Title.length > 0 && (
                <Modal.Header closeButton className="text-center">
                  <Modal.Title>{modal.Title}</Modal.Title>
                </Modal.Header>
              )}
              {isCreateNewGroup && (
                <Modal.Body>
                  <Form>
                    <Row>
                      <Form.Group
                        as={Col}
                        className={
                          "required " +
                          ((vehicleDocs.VehicleDocumentGroup?.documentGroupName?.length ?? 0) > 0
                            ? "filled"
                            : "")
                        }
                      >
                        <Form.Control
                          autoComplete="off"
                          type="text"
                          name="documentGroupName"
                          value={
                            vehicleDocs.VehicleDocumentGroup?.documentGroupName ?? ""
                          }
                          onChange={(e) => {
                            setNewGroupName(e.target.value);
                          }}
                          maxLength={50}
                        ></Form.Control>
                        <Form.Label>Document Group Name</Form.Label>
                        {documentGroups
                          .map((x) => x.documentGroupName.toLowerCase())
                          .includes(
                            (vehicleDocs.VehicleDocumentGroup?.documentGroupName ?? "").toLowerCase()
                          ) && (
                            <div className="text-danger font-small">
                              Document group name already exists.
                            </div>
                          )}
                      </Form.Group>
                    </Row>
                  </Form>
                </Modal.Body>
              )}
              <Modal.Footer>
                <Row className="w-100">
                  <Col className="text-center">
                    <Button
                      variant="light"
                      disabled={
                        isUploding ||
                        (isCreateNewGroup &&
                          ((vehicleDocs.VehicleDocumentGroup?.documentGroupName?.length ?? 0) === 0 ||
                            documentGroups
                              .map((x) => x.documentGroupName.toLowerCase())
                              .includes(
                                (vehicleDocs.VehicleDocumentGroup?.documentGroupName ?? "").toLowerCase()
                              )))
                      }
                      className={
                        "btn-save btn-default mr-2 w-100 " + modal.OkVariant
                      }
                      onClick={() => {
                        modal.HandleOk();
                      }}
                    >
                      {modal.OkText}
                    </Button>
                  </Col>
                </Row>
                <Row className="w-100">
                  <Col className="text-center">
                    <Button
                      disabled={isUploding}
                      variant="light"
                      className={
                        "btn-cancel btn-default w-100 " + modal.CancelVariant
                      }
                      onClick={() => {
                        modal.HandleClose();
                      }}
                    >
                      {modal.CancelText}
                    </Button>
                  </Col>
                </Row>
              </Modal.Footer>
            </Modal>
          )}
        </>
      )}
      {isShowLoading && <Spinner></Spinner>}
    </>
  );
}

export default withAITracking(reactPlugin, VehicleDocuemnts);
